import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind-aware class composition helper (ShadCN convention). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type ThemedAsset = {
  light: string;
  dark: string;
};

/** Pick the asset variant matching the active theme. */
export function getThemedContent(
  theme: string | undefined,
  asset: ThemedAsset
): string {
  return theme === 'dark' ? asset.dark : asset.light;
}
